import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {Kontekst} from "../Kontekst";
import {IQService} from "angular";
import {gettextCatalog} from "angular-gettext";
import {SøkRessurs} from "../ressurser/SøkRessurs";

export class SøkTjeneste {

    static regNavn = "SøkTjeneste";

    static forInjisering() {
        return [Kontekst.regNavn, SøkRessurs.regNavn, regNavn.gettext.gettextCatalog, regNavn.ng.$q, SøkTjeneste]
    }

    constructor(private kontekst: Kontekst, private søkRessurs: SøkRessurs, private gettextCatalog: gettextCatalog, private $q: IQService) {
        this.initTilgjengeligeEntiteter()
    }

    tilgjengeligeEntiteter: TilgjengeligEntitet[];

    //offentlige metoder

    entitetBasertPåEsType(esType:string):TilgjengeligEntitet{
        return _(this.tilgjengeligeEntiteter)
          .find(e => _(e.esType).includes(esType));
    }
    
    //hjelpemetoder


    private initTilgjengeligeEntiteter() {
        this.tilgjengeligeEntiteter = [
            {
                /// navn på søkbar entitet i søkdialog
                navn: this.gettextCatalog.getString("sak"),
                /// navn (flertall) på søkbar entitet i søkdialog
                navnFlertall: this.gettextCatalog.getString("saker"),
                type: l.SøkEntitetType.sak,
                esType: ['Sak'],
                valgt: true
            }, {
                /// navn på søkbar entitet i søkdialog
                navn: this.gettextCatalog.getString("dokument"),
                /// navn (flertall) på søkbar entitet i søkdialog
                navnFlertall: this.gettextCatalog.getString("dokumenter"),
                type: l.SøkEntitetType.dokument,
                esType: ['OpplastetDokumentVersjon'],
                valgt: true
            }, {
                /// navn på søkbar entitet i søkdialog
                navn: this.gettextCatalog.getString("møte"),
                /// navn (flertall) på søkbar entitet i søkdialog
                navnFlertall: this.gettextCatalog.getString("møter"),
                type: l.SøkEntitetType.møte,
                esType: ['Møte'],
                valgt: true
            }, {
                /// navn på søkbar entitet i søkdialog
                navn: this.gettextCatalog.getString("oppgave"),
                /// navn (flertall) på søkbar entitet i søkdialog
                navnFlertall: this.gettextCatalog.getString("oppgaver"),
                type: l.SøkEntitetType.oppgave,
                esType: ['Oppgave'],
                valgt: true
            }, {
                /// navn på søkbar entitet i søkdialog
                navn: this.gettextCatalog.getString("beslutning"),
                /// navn (flertall) på søkbar entitet i søkdialog
                navnFlertall: this.gettextCatalog.getString("beslutninger"),
                type: l.SøkEntitetType.beslutning,
                esType: ['Beslutning'],
                valgt: true
            }, {
                /// navn på søkbar entitet i søkdialog
                navn: this.gettextCatalog.getString("kommentar"),
                /// navn (flertall) på søkbar entitet i søkdialog
                navnFlertall: this.gettextCatalog.getString("kommentarer"),
                type: l.SøkEntitetType.kommentar,
                esType: ['Kommentar', 'Svar'],
                valgt: true
            }, {
                /// navn på søkbar entitet i søkdialog
                navn: this.gettextCatalog.getString("gruppe"),
                /// navn (flertall) på søkbar entitet i søkdialog
                navnFlertall: this.gettextCatalog.getString("grupper"),
                type: l.SøkEntitetType.gruppe,
                esType: ['Gruppe'],
                valgt: true
            }, {
                /// navn på søkbar entitet i søkdialog
                navn: this.gettextCatalog.getString("medlem"),
                /// navn (flertall) på søkbar entitet i søkdialog
                navnFlertall: this.gettextCatalog.getString("medlemmer"),
                type: l.SøkEntitetType.medlem,
                esType: ['Medlem'],
                valgt: true
            }, {
                /// navn på søkbar entitet i søkdialog
                navn: this.gettextCatalog.getString("bruker"),
                /// navn (flertall) på søkbar entitet i søkdialog
                navnFlertall: this.gettextCatalog.getString("brukere"),
                type: l.SøkEntitetType.bruker,
                esType: ['Bruker'],
                valgt: true
            }
        ];
    }

}


export interface TilgjengeligEntitet {
    navn: string;
    navnFlertall: string;
    type: l.SøkEntitetType;
    esType: string[],
    valgt: boolean;
}
